module.exports = __webpack_public_path__ + "img/train-tool-software.2cae6634.jpeg";